import React from 'react';
import {classes, style} from './doppe-action-type-link-view-widget.st.css';
import {doppeHideableValueIsHidden} from '../../../client-server-common/types/doppe-hideable-value';
import {DoppeActionGoalType, DoppeActionType} from '../../../client-server-common/doppe-action-types/doppe-action-type';
import {
    CouponSourceType,
    DoppeActionTypeCouponView
} from '../../../components/doppe-action-type-coupon-view/doppe-action-type-coupon-view';
import {
    DoppeActionTypeWidgetInnerDescription
} from '../../../components/doppe-action-type-widget-inner-description/doppe-action-type-widget-inner-description';
import {
    DoppeActionTypeWidgetInnerTitle
} from '../../../components/doppe-action-type-widget-inner-title/doppe-action-type-widget-inner-title';
import {DoppeActionTypeLinkView} from '../doppe-action-type-link-view';
import {arrayFirst, asArray, HtmlObjectResizeMode} from '@wix/devzai-utils-common';
import {DoppePageMediaView} from '../../../components/doppe-page-media-view/doppe-page-media-view';
import {
    DoppeActionTypeWidgetLayout
} from '../../../components/doppe-action-type-widget-layout/doppe-action-type-widget-layout';
import {IDoppeViewerActionContext} from '../../../doppe-sdk';
import {
    DoppeActionTypeWidgetContentLayoutNewWrapperSectionsAndButtons
} from '../../../components/doppe-action-type-widget-content-layout-new-wrapper-sections-and-buttons/doppe-action-type-widget-content-layout-new-wrapper-sections-and-buttons';


export const DoppeActionTypeLinkViewWidget = React.memo(function DoppeActionTypeLinkWidget(
    props: DoppeActionType.WidgetProps<DoppeActionTypeLinkView.ActionSettings>
) {
    const {
        actionContext,

        className,
        ...htmlAttributes
    } = props;

    return (
        <DoppeActionTypeWidgetLayout
            {...htmlAttributes}
            className={style(classes.root, {}, className)}
            actionContext={actionContext}
        >
            <DoppeActionTypeLinkWidgetInner
                actionContext={actionContext}
                reportGoalAchieved={(goalType) => {
                    actionContext.reportGoalAchieved({
                        goalType: goalType,
                    })
                }}
                actionId={actionContext.action.id}
                actionSettings={actionContext.action.settings}
            />
        </DoppeActionTypeWidgetLayout>
    );
});


export const DoppeActionTypeLinkWidgetInner = React.memo(function DoppeActionTypeLinkWidgetInner(
    props: {
        actionSettings: DoppeActionTypeLinkView.ActionSettings;
        reportGoalAchieved: (goalType: DoppeActionGoalType) => void;
        actionId: string;
        actionContext: IDoppeViewerActionContext;
        listItemId?: string;
    }
) {
    const {
        actionSettings,
        reportGoalAchieved,
        actionId,
        actionContext,
        listItemId
    } = props;

    const {
        url,
        description,
        title,
        couponCode,
        image,
    } = actionSettings;

    const firstImage = image ? arrayFirst(asArray(image)) : null;

    return (
        <DoppeActionTypeWidgetContentLayoutNewWrapperSectionsAndButtons
            actionContext={actionContext}
            reportGoalAchieved={reportGoalAchieved}
            mainMedia={firstImage ? (
                <div
                    className={style(classes.imageContainer, {})}
                >
                    <DoppePageMediaView
                        className={style(classes.image, {})}
                        mediaResource={firstImage}
                        layoutSpec={{autoHeight: true, maxHeight: 360}}
                        widthSpec={{contentRelativeWidth: 1}}
                        mediaResizeMode={HtmlObjectResizeMode.Cover}
                    />
                </div>
            ) : null}
            sections={actionSettings.sections}
            buttons={actionSettings.ctaButtons}
            buttonsSettings={{
                sourceURL: url,
                listItemId: listItemId,
            }}
        >
            <DoppeActionTypeWidgetInnerTitle>
                {title}
            </DoppeActionTypeWidgetInnerTitle>

            <DoppeActionTypeWidgetInnerDescription
                className={style(classes.couponDescription, {})}
            >
                {description}
            </DoppeActionTypeWidgetInnerDescription>
            {
                !doppeHideableValueIsHidden(couponCode) ?
                    <DoppeActionTypeCouponView
                        className={style(classes.couponView, {})}
                        coupon={couponCode}
                        couponSourceType={CouponSourceType.Action}
                        actionId={actionId}
                        onCouponCopied={() => {
                            reportGoalAchieved(DoppeActionGoalType.CouponCopied);
                        }}
                    />
                    :
                    null
            }
        </DoppeActionTypeWidgetContentLayoutNewWrapperSectionsAndButtons>
    );
});